import React, { createContext, useContext, useState, useEffect } from 'react';
import { config, getAccount, getAllDocuments, getCurrentUser } from '../lib/appwrite';
import { useLocation, useNavigate } from 'react-router-dom';

const StateContext = createContext();

export const ContextProvider = ({ children }) => {
    const [activeMenu, setActiveMenu] = useState(true);
    const [screenSize, setScreenSize] = useState(undefined)
    const [currentColor, setCurrentColor] = useState('#1E4DB7')
    const [currentMode, setCurrentMode] = useState('Light')
    const [themeSettings, setThemeSettings] = useState(false)
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [allowedPages, setAllowedPages] = useState([])

    const [account, setAccount] = useState(null);

    useEffect(() => {
        const fetchAccount = async () => {
            try {
                const fetchedAccount = await getAccount();
                if (fetchedAccount) {
                    setAccount(fetchedAccount);
                    setIsLoggedIn(true);
                } else {
                    setIsLoggedIn(false);
                    setAccount(null);
                }
                setCurrentMode(localStorage.getItem("themeMode"));
                setCurrentColor(localStorage.getItem("colorMode"));
            } catch (error) {
                // User is not logged in, which is fine
                setIsLoggedIn(false);
                setAccount(null);
            }
        };

        fetchAccount(); // Call the fetchAccount function when the component mounts
    }, []);

    const fetchAllowedPages = async () => {
        try {
            const user = await getCurrentUser()
            
            // For now, if user is admin, allow all admin pages
            // This can be expanded later with a proper permissions system
            if (user && user.permissions === 'admin') {
                return [
                    '/',
                    '/admin',
                    '/admin/account',
                    '/admin/dashboard',
                    '/admin/testimonials',
                    '/admin/messages',
                    '/admin/photos',
                    '/admin/customers',
                    '/admin/calendar',
                    '/access-control'
                ];
            }
            
            // For non-admin users, return empty array (no access)
            // This can be customized based on user permissions
            return [];
        } catch (error) {
            console.error('Error fetching allowed pages:', error);
            return [];
        }
    }


    const setMode = (value) => {

        setCurrentMode(value)

        localStorage.setItem('themeMode', value)
        setThemeSettings(false)
    }

    const setColor = (color) => {
        setCurrentColor(color)

        localStorage.setItem('colorMode', color)
        setThemeSettings(false)
    }

    return (
        <StateContext.Provider
            value={{
                activeMenu,
                setActiveMenu,
                screenSize,
                setScreenSize,
                currentColor,
                setCurrentColor,
                currentMode,
                setCurrentMode,
                setColor,
                setMode,
                themeSettings,
                setThemeSettings,
                isLoggedIn,
                setIsLoggedIn,
                account,
                setAccount,
                allowedPages,
                fetchAllowedPages
            }}
        >
            {children}
        </StateContext.Provider>
    )
}

export const useStateContext = () => useContext(StateContext);